import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggingService } from './logic/logging.service';
import { LoggingDaoService } from './dao/logging-dao.service';
import { LoggingDbDaoService } from './dao/logging-db-dao/logging-db-dao.service';
import { environment } from 'src/environments/environment';
import { LoggingDbTableDefinition } from './dao/logging-db-dao/logging-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: LoggingService, useClass: environment.loggingService },
    { provide: LoggingDaoService, useClass: LoggingDbDaoService },
    { provide: LoggingDbTableDefinition },
  ]
})
export class LoggingModule {}
